<template>
  <div>
    <div class="page-head">
      <div>
        <h2>美食推荐</h2>
        <p>维护美食推荐页展示的餐厅、小吃和特色美食。</p>
      </div>
      <el-button type="primary" @click="openCreate">新增美食</el-button>
    </div>

    <el-card shadow="never">
      <el-form :inline="true" :model="filters" size="small">
        <el-form-item label="关键词"><el-input v-model="filters.keyword" placeholder="名称/分类/区域" clearable /></el-form-item>
        <el-form-item label="展示状态">
          <el-select v-model="filters.status" placeholder="全部" clearable>
            <el-option label="展示中" value="active" />
            <el-option label="已隐藏" value="inactive" />
          </el-select>
        </el-form-item>
        <el-form-item><el-button type="primary" @click="fetchList">查询</el-button><el-button @click="reset">重置</el-button></el-form-item>
      </el-form>

      <paged-table :rows="rows" :loading="loading" :page="page" :page-size="pageSize" :total="total" @page-change="page = $event; fetchList()" @size-change="pageSize = $event; page = 1; fetchList()">
        <el-table-column prop="id" label="ID" width="80" />
        <el-table-column label="预览" width="110">
          <template slot-scope="{ row }">
            <el-image v-if="row.cover_url" class="food-thumb" :src="row.cover_url" fit="cover" />
            <span v-else class="muted">未上传</span>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="名称" min-width="180" />
        <el-table-column prop="category" label="分类" width="120" />
        <el-table-column prop="area" label="区域" width="120" />
        <el-table-column prop="avg_price" label="人均" width="100" />
        <el-table-column label="可加入意向" width="110"><template slot-scope="{row}">{{ row.can_add_trip ? '是' : '否' }}</template></el-table-column>
        <el-table-column label="标签" min-width="180">
          <template slot-scope="{ row }">
            <el-tag v-for="tag in normalizeTags(row.tags_json)" :key="tag" size="mini" class="table-tag">{{ tag }}</el-tag>
            <span v-if="!normalizeTags(row.tags_json).length" class="muted">-</span>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="小程序展示" width="160">
          <template slot-scope="{ row }"><publish-switch :value="row.status" @change="changeStatus(row, $event)" /></template>
        </el-table-column>
        <el-table-column prop="sort_order" label="排序" width="130">
          <template slot-scope="{ row }"><sort-input :value="Number(row.sort_order || 0)" @change="changeSort(row, $event)" /></template>
        </el-table-column>
        <el-table-column label="操作" width="150" fixed="right">
          <template slot-scope="{ row }">
            <el-button type="text" @click="openEdit(row)">编辑</el-button>
            <el-button type="text" class="danger-text" @click="remove(row)">删除</el-button>
          </template>
        </el-table-column>
      </paged-table>
    </el-card>

    <el-dialog :title="drawerMode === 'create' ? '新增美食推荐' : '编辑美食推荐'" :visible.sync="drawerVisible" width="600px" destroy-on-close>
      <el-form ref="form" class="drawer-form" :model="form" :rules="rules" label-width="120px">
        <el-form-item label="名称" prop="name"><el-input v-model="form.name" /></el-form-item>
        <el-form-item label="分类"><el-input v-model="form.category" /></el-form-item>
        <el-form-item label="区域"><el-input v-model="form.area" /></el-form-item>
        <el-form-item label="人均价格"><el-input-number v-model="form.avg_price" :min="0" :precision="2" /></el-form-item>
        <el-form-item label="适合人群"><el-input v-model="form.suitable_people" /></el-form-item>
        <el-form-item label="推荐点单"><el-input v-model="form.recommend_dishes" type="textarea" :rows="2" /></el-form-item>
        <el-form-item label="行程建议"><el-input v-model="form.trip_advice" type="textarea" :rows="2" /></el-form-item>
        <el-form-item label="可加入意向"><el-switch v-model="form.can_add_trip" /><div class="field-help">行程意向与收藏分开记录；关闭后小程序不显示加入意向按钮。</div></el-form-item>
        <el-form-item label="封面图" prop="cover_url"><asset-upload v-model="form.cover_url" type="image" category="foods" /></el-form-item>
        <el-form-item label="详情图"><asset-upload v-model="form.detail_image_url" type="image" category="foods" /></el-form-item>
        <el-form-item label="美食标签">
          <div class="tag-editor">
            <el-tag v-for="tag in form.tags_json" :key="tag" closable @close="removeTag(tag)">{{ tag }}</el-tag>
            <el-input
              v-if="tagInputVisible"
              ref="tagInput"
              v-model="tagInput"
              class="tag-input"
              size="small"
              @keyup.enter.native="confirmTag"
              @blur="confirmTag"
            />
            <el-button v-else size="small" @click="showTagInput">添加标签</el-button>
          </div>
        </el-form-item>
        <el-form-item label="推荐理由"><el-input v-model="form.description" type="textarea" :rows="5" /></el-form-item>
      </el-form>
      <div class="drawer-footer">
        <el-button @click="drawerVisible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="save">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import AssetUpload from "../components/AssetUpload.vue";
import PagedTable from "../components/PagedTable.vue";
import PublishSwitch from "../components/PublishSwitch.vue";
import SortInput from "../components/SortInput.vue";
import { changeResourceStatus, createResource, deleteResource, listResource, updateResource } from "../api/resources";

export default {
  name: "FoodsManage",
  components: { AssetUpload, PagedTable, PublishSwitch, SortInput },
  data() {
    return {
      loading: false,
      saving: false,
      drawerVisible: false,
      drawerMode: "create",
      rows: [],
      total: 0,
      page: 1,
      pageSize: 20,
      filters: { keyword: "", status: "" },
      tagInput: "",
      tagInputVisible: false,
      form: this.emptyForm(),
      rules: {
        name: [{ required: true, message: "请填写名称", trigger: "blur" }],
        cover_url: [{ required: true, message: "请上传封面图", trigger: "change" }]
      }
    };
  },
  mounted() {
    this.fetchList();
  },
  methods: {
    emptyForm() {
      return { name: "", category: "", area: "", avg_price: 0, suitable_people:"", recommend_dishes:"", trip_advice:"", can_add_trip:true, cover_url: "", detail_image_url: "", tags_json: [], description: "" };
    },
    normalizeTags(value) {
      if (Array.isArray(value)) return value.filter(Boolean);
      if (!value) return [];
      try {
        const parsed = JSON.parse(value);
        return Array.isArray(parsed) ? parsed.filter(Boolean) : [];
      } catch (error) {
        return String(value)
          .split(/[，,]/)
          .map((item) => item.trim())
          .filter(Boolean);
      }
    },
    async fetchList() {
      this.loading = true;
      try {
        const res = await listResource("food-items", { ...this.filters, page: this.page, pageSize: this.pageSize });
        this.rows = res.data && res.data.items ? res.data.items : [];
        this.total = res.data && res.data.total ? res.data.total : 0;
      } finally {
        this.loading = false;
      }
    },
    reset() {
      this.filters = { keyword: "", status: "" };
      this.page = 1;
      this.fetchList();
    },
    openCreate() {
      this.drawerMode = "create";
      this.form = this.emptyForm();
      this.tagInput = "";
      this.tagInputVisible = false;
      this.drawerVisible = true;
    },
    openEdit(row) {
      this.drawerMode = "edit";
      this.form = { ...this.emptyForm(), ...row, tags_json: this.normalizeTags(row.tags_json), can_add_trip: Boolean(row.can_add_trip) };
      this.tagInput = "";
      this.tagInputVisible = false;
      this.drawerVisible = true;
    },
    showTagInput() {
      this.tagInputVisible = true;
      this.$nextTick(() => {
        if (this.$refs.tagInput) this.$refs.tagInput.focus();
      });
    },
    confirmTag() {
      const value = this.tagInput.trim();
      if (value && !this.form.tags_json.includes(value)) {
        this.form.tags_json.push(value);
      }
      this.tagInput = "";
      this.tagInputVisible = false;
    },
    removeTag(tag) {
      this.form.tags_json = this.form.tags_json.filter((item) => item !== tag);
    },
    save() {
      this.$refs.form.validate(async (valid) => {
        if (!valid) return;
        this.saving = true;
        try {
          if (this.drawerMode === "create") await createResource("food-items", this.form);
          else await updateResource("food-items", this.form.id, this.form);
          this.$message.success("美食推荐已保存");
          this.drawerVisible = false;
          this.fetchList();
        } finally {
          this.saving = false;
        }
      });
    },
    async changeStatus(row, status) {
      await changeResourceStatus("food-items", row.id, status);
      this.$message.success(status === "active" ? "美食已展示" : "美食已隐藏");
      this.fetchList();
    },
    async changeSort(row, sortOrder) {
      await updateResource("food-items", row.id, { ...row, sort_order: sortOrder });
      this.$message.success("排序已更新");
      this.fetchList();
    },
    remove(row) {
      this.$confirm("确定删除该美食推荐吗？", "删除推荐", { type: "warning" })
        .then(async () => {
          await deleteResource("food-items", row.id);
          this.$message.success("美食推荐已删除");
          this.fetchList();
        })
        .catch(() => {});
    }
  }
};
</script>

<style scoped>
.food-thumb {
  width: 72px;
  height: 48px;
  border-radius: 6px;
  background: #f2f3f5;
}

.table-tag {
  margin: 0 6px 6px 0;
}

.tag-editor {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
}

.tag-input {
  width: 110px;
}

.muted {
  color: #909399;
}
.field-help { margin-top:6px;color:#909399;font-size:12px; }
</style>
